$ = require 'jquery'
Util = require 'app/scripts/lib/util'
AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
{ track } = require '@trello/analytics'
Browser = require '@trello/browser'
{ getPotentialCovers } = require 'app/src/components/CardCoverChooser/SelectCover'
{ toggleCardCoverChooserPopover } = require 'app/scripts/views/card/card-cover-chooser-popover.tsx'
{ UnsplashTracker } = require '@trello/unsplash'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
pluginCoverWithDefaults = require 'app/scripts/lib/plugins/plugin-cover-with-defaults'

module.exports.openCoverInViewer = (e) ->
  Util.stop(e)
  if !@showCover()
    return

  coverModel = @model.attachmentList.get(@model.get('idAttachmentCover'))
  if !AttachmentViewer.isActive()
    AttachmentViewer.show
      model: @model
      attachmentModel: coverModel
    track("Card Detail", "Open Attachment Viewer via Cover", coverModel.getType(), @model.trackProperty())
  return

module.exports.removeCover = (e) ->
  Util.stop(e)
  @model.removeCover(null)
  track("Card Detail", "Card Cover", "Remove Cover", @model.trackProperty())
  return

module.exports.showCover = ->
  @model.getBoard().getPref('cardCovers') && @model.hasCover()

module.exports.checkShowCover = ->
  hasCover = @showCover() || @hasPluginCover
  hasStickers = @model.hasStickers()

  if hasCover
    @$('.js-card-cover-box')
      .removeClass('hide window-cover-stickers-only')
      .addClass('is-covered')
      .toggleClass('has-attachment-cover', @model.hasAttachmentCover())
  else if hasStickers
    @$('.js-card-cover-box')
    .removeClass('hide is-covered')
    .addClass('window-cover-stickers-only')
  else
    @$('.js-card-cover-box').addClass('hide')

  return

module.exports.clearCover = ->
  $cardCoverBox = @$('.js-card-cover-box')
  $cardCoverBox.css
    'background-color': ''
    'background-image': ''
    'height': ''
    'padding': ''

  $cardCoverBox.removeClass (index, className) ->
    return (className.match(/\bcolor-card-cover-\S+/g) || []).join(' ')

  btnClasses = [
    'dialog-close-button-light'
    'dialog-close-button-dark'
  ]

  $('.dialog-close-button').removeClass(btnClasses.join(' '))
  @$('.window-sidebar').find('.js-card-cover-chooser').removeClass('hide')

module.exports.renderCover = ->
  @clearCover()

  hasCoverMenu = @model.editable()
  canHaveCover = @model.getBoard().getPref('cardCovers')
  showHeaderCoverChooser = @showCover() && hasCoverMenu
  showSidebarChooser = !showHeaderCoverChooser && canHaveCover && hasCoverMenu

  applyCover = ({ url, height, size, edgeColor, color, brightness, position, padding }) =>
    position ?= 'center'
    padding ?= '0'
    brightness ?=
      if edgeColor && edgeColor != 'transparent'
        [r, g, b] = edgeColor.match(/[0-9a-f]{2}/ig).map (v) -> parseInt(v, 16)

        avg = (r + g + b) / 3
        if avg >= 140
          'light'
        else if avg < 140
          'dark'

    $cardCoverBox = @$('.js-card-cover-box')
    # This button isn't contained in the view, but we're trying to control the style
    # anyway
    $closeButton = $('.dialog-close-button')

    $cardCoverBox.removeClass('card-cover-dark card-cover-light')

    $closeButton.removeClass('dialog-close-button-dark dialog-close-button-light dialog-close-button-indeterminate')

    if color
      $cardCoverBox.addClass("color-card-cover color-card-cover-#{color}")
      position = 'left'
    else
      backgroundColor = edgeColor ? 'transparent'
      $cardCoverBox.css('background-color', backgroundColor)

    btnClass =
      switch brightness
        when 'light' then 'dark'
        when 'dark' then 'light'
        else 'indeterminate'

    if btnClass?
      $closeButton.addClass("dialog-close-button-#{btnClass}")
      $cardCoverBox.addClass("card-cover-#{brightness}")

    $cardCoverBox
      .css
        'background-image': if url then "url(\"#{url}\")" else ''
        'height': height
        'background-size': size
        'background-origin': 'content-box'
        'padding': padding
        'box-sizing': 'border-box'
        'background-position': position


    # TODO: This was previously indented one level deeper. We need to validate that changing the deptch is still correct.
    $cardCoverBox.find('.window-cover-menu').toggleClass('hide', !showHeaderCoverChooser)
    @$('.window-sidebar').find('.js-card-cover-chooser').toggleClass('hide', !showSidebarChooser)


  if @showCover()
    cover = @model.get('cover')

    { previews, edgeColor, color, brightness } =
      if cover?.color
        { color: cover.color, brightness: cover.brightness }
      else if cover?.idAttachment || cover?.idUploadedBackground
        {
          previews: cover.scaled
          edgeColor: cover.edgeColor
          # NOTE: the card cover brightness isn't getting set so we're always
          # getting back the default 'light'.  Once that's fixed we can use
          # the cover brightness instead of calculating it from the edgeColor.
          #brightness: cover.brightness
        }
      else
        {}

    if hasCoverMenu
      MIN_HEIGHT = 116
    else
      MIN_HEIGHT = 48

    MAX_HEIGHT = 160
    MAX_WIDTH = 730

    if (color? && @colorCoversFlagEnabled) || previews?
      @hasPluginCover = false
      if Browser.isHighDPI()
        maxWidth = MAX_WIDTH * 2
        maxHeight = MAX_HEIGHT * 2
      else
        maxWidth = MAX_WIDTH
        maxHeight = MAX_HEIGHT

      # Find the smallest preview that has a height that exceeds the maximum
      # height we'll give to a card cover, and doesn't exceed the width of a
      # card.
      preview = Util.smallestPreviewBetween(previews, 0, maxHeight, maxWidth, Infinity) ?
        Util.biggestPreview(previews)

      if color
        height = MIN_HEIGHT
        size = 'initial'
      else
        if preview?
          coverImgUrl = preview.url
        else
          # NOTE: This fallback is unsuitable if we're showing previews for things that
          # aren't image attachments
          coverImgUrl = attachmentCover.get('url')

        height = Math.max(MIN_HEIGHT, Math.min(preview?.height ? MAX_HEIGHT, MAX_HEIGHT))
        size = if preview?.height < height then 'initial' else 'contain'

      applyCover({ url: coverImgUrl, height, size, edgeColor, color, brightness })

      if cover?.idUploadedBackground
        UnsplashTracker.trackOncePerInterval(cover.sharedSourceUrl)

  else if @model.getBoard().getPref('cardCovers')
    PluginRunner.one
      command: 'card-cover'
      board: @model.getBoard()
      card: @model
      list: @model.getList()
      timeout: 10000
      options:
        attachments: PluginModelSerializer.attachments(@model.attachmentList.models, ['id', 'name', 'url'])
        cardDetail: true
    .catch PluginRunner.Error.NotHandled, ->
      null
    .then (pluginCover) =>
      if !pluginValidators.isValidCover(pluginCover, true)
        @hasPluginCover = false
        return
      { url, height, size, edgeColor, position, padding } = pluginCoverWithDefaults(pluginCover)
      @hasPluginCover = true
      applyCover({ url, height, size, edgeColor, position, padding })
      @checkShowCover()
    .done()

  @checkShowCover()

  @

module.exports.cardCoverChooserSidebar = (e) ->
  Util.preventDefault(e)

  toggleCardCoverChooserPopover({
    elem: @$(e.currentTarget)
    cardId: @model.id
  })

  inHeader = @$(e.currentTarget).closest('.js-card-cover-box').length > 0

  attachments = @model.attachmentList.toJSON()
  coverAttachmentCount = getPotentialCovers(attachments).length
  hasPotentialCovers = coverAttachmentCount > 0 || @model.hasCover()
  hasCoversProperty = if hasPotentialCovers then "Has Potential Covers" else "No Covers"

  if inHeader
    track("Card Detail", "Card Cover Area", "Open Card Cover Chooser", hasCoversProperty, coverAttachmentCount)
    track("Card Detail", "Card Cover Area", "Open Card Cover Chooser", @model.trackProperty())
  else
    track("Card Detail", "Sidebar", "Open Card Cover Chooser", hasCoversProperty, coverAttachmentCount)
    track("Card Detail", "Sidebar", "Open Card Cover Chooser", @model.trackProperty())
  false
